import React from "react";
import { useTranslation } from "react-i18next";
import errorIcon from "../../assets/images/error-icon.png";
import ErrorRenderProps from "./ErrorRenderProps";
import "./ErrorRender.scss";

const ErrorRender = (props: ErrorRenderProps) => {
  const { t } = useTranslation("common");
  return (
    <div
      className="error-render-content"
      style={{
        width: `${props.width ? props.width : ""}`,
        margin: `${props.margin ? props.margin : ""}`,
      }}
    >
      <div className="d-flex align-items-center error-render-wrapper">
        <img src={errorIcon} alt="" />
        <div className="error-render-labels-wrapper">
          <span className="error-render-attention">
            {props.headerLabel
              ? props.headerLabel
              : t("ErrorRender.headerLabel")}
          </span>
          <span className="error-render-label">
            {props.label ? props.label : t("ErrorRender.label")}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ErrorRender;
